<!-- prettier-ignore -->
<nav class="nav-body" [ngClass]="{
    'navbar-expanded': isExpanded,
    'navbar-not-expanded': !isExpanded,
    tempClass: brokerAdminfirstTimeLogin
  }">
  <div class="container-fluid">
    <!-- Left side: Toggle button or empty spacer -->
    <div class="navbar-left">
      <!-- Sidebar Toggle Button - Always visible except during first-time login -->
      @if (!brokerAdminfirstTimeLogin) {
        <p-button 
          [icon]="isExpanded ? 'pi pi-bars' : 'pi pi-bars'" 
          (click)="toggleSidebar()"
          [text]="true" 
          [plain]="true"
          styleClass="sidebar-toggle-btn" role="button" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && $any($event.currentTarget).click()" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && $any($event.currentTarget).click()">
        </p-button>
      }
    </div>

    <!-- Right side: User info -->
    <div class="userInfo" (click)="userDropdown.toggle($event)" style="cursor: pointer;" role="button" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && $any($event.currentTarget).click()" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && $any($event.currentTarget).click()">
      <p-avatar 
        [label]="((userFirstNameAlphabet || '') + (userLastNameAlphabet || '')).toUpperCase()" 
        styleClass="user-avatar" 
        size="normal" 
        shape="circle">
      </p-avatar>
      
     <div class="d-flex"> <div class="user-details">
         <div class="user-fullname">
           {{ userFirstName | titlecase }} {{ userLastName | titlecase}}
         </div>
         <!-- <div class="user-arn">
           {{userOrgArn}}
         </div> -->
      </div>

      <!-- Menu Button -->
      <p-button 
        icon="pi pi-chevron-down" 
        [plain]="true" 
        [text]="true"
        styleClass="user-menu-button">
      </p-button>
     <!-- Custom User Dropdown -->
      <p-popover 
        #userDropdown 
        styleClass="premium-user-dropdown">
        
        <!-- Menu Actions -->
        <div class="dropdown-menu-items">
          @if (!brokerAdminfirstTimeLogin && role !== 'ADMIN') {
            <div class="menu-item" 
                 (click)="showProfile(); userDropdown.hide()" role="button" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && $any($event.currentTarget).click()" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && $any($event.currentTarget).click()">
              <i class="pi pi-user menu-icon"></i>
              <span class="menu-text">View Profile</span>
              <i class="pi pi-angle-right menu-arrow"></i>
            </div>
          }

          @if (role === 'BROKER ADMIN' && !hasBSECreds) {
            <div class="menu-item" 
                 (click)="onbaordBse(); userDropdown.hide()" role="button" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && $any($event.currentTarget).click()" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && $any($event.currentTarget).click()">
              <i class="pi pi-cog menu-icon"></i>
              <span class="menu-text">Setup BSE Credentials</span>
            </div>
          } 

          @if (helpAvailable) {
            <div class="menu-item" (click)="startHelp(); userDropdown.hide()" role="button" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && $any($event.currentTarget).click()" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && $any($event.currentTarget).click()">
              <i class="pi pi-question-circle menu-icon"></i>
              <span class="menu-text">Help</span>
              <i class="pi pi-angle-right menu-arrow"></i>
            </div>
          }

          <div class="menu-item logout-item" (click)="logout(); userDropdown.hide()" role="button" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && $any($event.currentTarget).click()" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && $any($event.currentTarget).click()">
            <i class="pi pi-sign-out menu-icon"></i>
            <span class="menu-text">Sign Out</span>
          </div>
        </div>
      </p-popover></div>

     
    </div>
  </div>
</nav>
